import classNames from "classnames";
import { JSX, Ref } from "react";
import styles from "./Textarea.module.css";

export type Props = JSX.IntrinsicElements["textarea"] & {
  ref?: Ref<HTMLTextAreaElement>;
  fullWidth?: boolean;
};

const Textarea = ({ ref, fullWidth, ...props }: Props) => {
  return (
    <textarea
      ref={ref}
      {...props}
      className={classNames(styles.textarea, props.className, {
        [styles.fullWidth]: fullWidth,
      })}
    />
  );
};

export default Textarea;
